import { render, staticRenderFns } from "./TgiSrPlus.vue?vue&type=template&id=5b91cbae&scoped=true&lang=pug&"
import script from "./TgiSrPlus.vue?vue&type=script&lang=ts&"
export * from "./TgiSrPlus.vue?vue&type=script&lang=ts&"
import style0 from "./TgiSrPlus.vue?vue&type=style&index=0&id=5b91cbae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91cbae",
  null
  
)

export default component.exports